import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
// eslint-disable-next-line import/no-unassigned-import
import "swiper/css";
// eslint-disable-next-line import/no-unassigned-import
import "swiper/css/navigation";
// eslint-disable-next-line import/no-unassigned-import
import "swiper/css/pagination";
import { Navigation, Pagination, Autoplay } from "swiper";
import { Box, Flex, Button } from "@chakra-ui/react";
import { type Integration, type IntegrationSimple } from "lib/sanity";
import { Link } from "ui/link";
import { ChevronLeftIcon, ChevronRightIcon } from "ui/icons";

type XtoYLinkSliderProps = {
  variant: "allDestinations" | "allSources";
  integrationChunks: IntegrationSimple[][];
  primaryIntegration: Integration;
  slidesPerView: number;
  // eslint-disable-next-line react/boolean-prop-naming
  loop?: boolean;
};
export function XtoYLinkSlider({
  variant,
  primaryIntegration,
  integrationChunks,
  slidesPerView,
  loop,
}: XtoYLinkSliderProps) {
  const previousSlideButton = useRef<HTMLButtonElement>(null);
  const nextSlideButton = useRef<HTMLButtonElement>(null);

  return (
    <Box>
      <Swiper
        loop={loop}
        speed={450}
        threshold={2}
        slidesPerView={slidesPerView}
        modules={[Autoplay, Pagination, Navigation]}
        navigation={{
          prevEl: previousSlideButton.current,
          nextEl: nextSlideButton.current,
        }}
      >
        {integrationChunks.map((integrations, index) => (
          <SwiperSlide key={`destination-group-${index}`}>
            <Flex direction="column" gap={4} mr={12}>
              {integrations.map((currentIntegration) => {
                const href =
                  variant === "allDestinations"
                    ? `/integrations/${primaryIntegration.slug}-to-${currentIntegration.slug}`
                    : `/integrations/${currentIntegration.slug}-to-${primaryIntegration.slug}`;
                const linkText =
                  variant === "allDestinations"
                    ? `${primaryIntegration.name} to ${currentIntegration.name}`
                    : `${currentIntegration.name} to ${primaryIntegration.name}`;
                return (
                  <Box key={currentIntegration.slug}>
                    <Link
                      key={currentIntegration.slug}
                      variant="article"
                      href={href}
                      size="md"
                      _hover={{ opacity: 0.9 }}
                    >
                      {linkText}
                    </Link>
                  </Box>
                );
              })}
            </Flex>
          </SwiperSlide>
        ))}
      </Swiper>

      <Flex mt={{ base: 6, md: 9 }} gap={8}>
        <Button ref={previousSlideButton} aria-label="Previous slide." variant="dark" pl={3}>
          <ChevronLeftIcon color="white" boxSize={5} mr={1.5} />
          Prev
        </Button>
        <Button ref={nextSlideButton} aria-label="Next slide." variant="dark" pr={3}>
          Next
          <ChevronRightIcon color="white" boxSize={5} ml={1.5} />
        </Button>
      </Flex>
    </Box>
  );
}
